import O1HD from "../../../engines/gameEngine";
import utilsModel from "../../../engines/libs/utilsModel";
import NormalGameManager, {RegisterSpecialEventEntity} from "../manager/NormalGameManager";
import {EventParamsTypeConstant} from "./const/EventParamsTypeConstant";

const {ccclass, property} = cc._decorator;

/**
 * 洗浴中心
 */
@ccclass
export default class BathCenterPrefab extends cc.Component {

    @property(cc.PageView)
    pageView : cc.PageView = null;
    @property(cc.Node)
    leftNode : cc.Node = null;
    @property(cc.Node)
    rightNode : cc.Node = null;
    @property(cc.Node)
    curtainLeftNode : cc.Node = null;
    @property(cc.Node)
    curtainRightNode : cc.Node = null;

    onLoad () {}

    start () {
        this.pageView.setCurrentPageIndex(0);
        this.pageView.node.on('page-turning', this.pageChange, this);
        O1HD.getManagers().soundMgr.playSound("meimeitalk").then((id:number)=>{
            this.mSoundId = id;
        });
    }

    /**
     * 退出
     */
    onBtnExit( e ){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.node.parent.removeFromParent();
        this.node.parent.destroy();
    }

    /**
     * 按摩
     */
    onBtnMassage( e , channel ){
        // 判断金钱是否足够
        let needPayMoney : number = 0;
        let hour : number = 1;
        let stronger : number = -5;
        switch ( channel ) {
            case "1":
                needPayMoney = 199 ;
                break;
            case "2":
                stronger = 100;
                hour = 2;
                needPayMoney = 399 ;
                break;
        }
        if ( O1HD.getServices().userSrv.getCoins() - needPayMoney < 0 ){
            O1HD.getModules().uiControlModule.showMessageBox("金钱不足",this.node);
            NormalGameManager._instance.openBankPage();
            return;
        }
        //扣除钱
        O1HD.getServices().userSrv.setCoins( -needPayMoney , true ,e.target);

        this.node.getChildByName("contentNode").active = false;
        cc.tween( this.curtainLeftNode )
            .to( 2 , {x : -200 })
            .call(()=>{
                this.schedule(()=>{
                    this._close( channel , stronger ,hour );
                },1);
            })
            .start();
        cc.tween( this.curtainRightNode )
            .to( 2 , {x : 200 })
            .call(()=>{

            })
            .start();
    }


    private _close( channel : string , stronger : number , hour : number ){
        let specialEventArray : RegisterSpecialEventEntity[] = [];
        let itemEntity : RegisterSpecialEventEntity = null;
        // 按摩任务注册
        switch ( channel ) {
            case "1":
                itemEntity = {
                    startHours : 0,
                    waitHours : 0,
                    desc : `你感觉神清气爽,精神抖擞,整个人充满了干劲!心里想着下次还要再来!`,
                    effectParams : [
                        { key : EventParamsTypeConstant.HEALTH , value : 10 },
                        { key : EventParamsTypeConstant.MOOD , value : 20 },
                        { key : EventParamsTypeConstant.STRONGER , value : stronger },
                        { key : EventParamsTypeConstant.HOUR , value : hour },
                    ]
                };
                break;
            case "2":
                itemEntity = {
                    startHours : 0,
                    waitHours : 0,
                    desc : `你整个人飘飘欲仙,是一种从来没有体验过的感觉,虽然饿的可以一口吃下一头牛!`,
                    effectParams : [
                        { key : EventParamsTypeConstant.HEALTH , value : 100 },
                        { key : EventParamsTypeConstant.MOOD , value : 100 },
                        { key : EventParamsTypeConstant.STRONGER , value : stronger },
                        { key : EventParamsTypeConstant.HOUR , value : hour },
                    ]
                };
                O1HD.getServices().userSrv.setStronger(100,false );
                //重置连续工作时间
                O1HD.emit("NormalGameManager.resetContinuesWorkHour" );
                break;
        }
        specialEventArray.push(itemEntity);
        let showFlag = true;
        // 特殊事件是否触发 , 洗浴中心
        if ( !O1HD.getServices().localStorageSrv.getStorage("bathCenterPrefab-event-ids" )  || O1HD.getServices().localStorageSrv.getStorage("bathCenterPrefab-event-ids" ) == "0" ) {
            if ( O1HD.getServices().userSrv.getCoins() < 10 ) {
                showFlag = false;
                let itemEntity : RegisterSpecialEventEntity = {
                    startHours : 0,
                    waitHours : 0,
                    desc : `按摩技师很同情你，将她的报酬分出一部分给你，并给你加油`,
                    chooseArray:[
                        {
                            chooseItemName : "知道了",
                            desc : "她说：每个人生来都有很多花种，你就是喜欢将花儿种在他人心里而放任自己内心一片荒芜",
                            effectParams : [
                                { key : EventParamsTypeConstant.MONEY , value : 50 }
                            ]
                        },
                    ]
                };
                O1HD.emit("normalMode.setImgEventShow", itemEntity );
                O1HD.getServices().localStorageSrv.setStorage("bathCenterPrefab-event-ids" , 1 );
            }
        }
        O1HD.emit("normalMode.setSpecialEventShow", specialEventArray , showFlag);
        this.node.parent.removeFromParent();
        this.node.parent.destroy();
    }

    /**
     * 广告解锁
     */
    onBtnAdUnlock(e : cc.Event.EventTouch, define : string ){
        utilsModel.loadAndShowVideoAdTrans(()=>{
            e.target.active = false;
            if ( define == "ruhua" ){
                e.target.parent.getChildByName("cfhgt").active = false;
                e.target.parent.getChildByName("cf").active = true;
                e.target.parent.getChildByName("nameFrame").opacity = 0;
                e.target.parent.getChildByName("nameFrame").active = true;
                O1HD.getManagers().soundMgr.playSound("ruhua").then();
                cc.tween( e.target.parent.getChildByName("nameFrame") )
                    .to( 1 ,{opacity:255})
                    .call(()=>{})
                    .start();
                this.scheduleOnce(()=>{
                    this.onBtnSelectGirl( null , "4" );
                },4 );
            }
        },()=>{
            O1HD.getModules().uiControlModule.showMessageBox("观看广告失败",this.node );
        },()=>{

        },"girl3解锁");
    }


    private mSoundId : number;
    /**
     * 选择女生
     */
    async onBtnChangeGirl( e , uniqueStr : string ){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();

        // if ( this.mSoundId ) {
        //     O1HD.getManagers().soundMgr.stopSound( this.mSoundId );
        //     this.mSoundId = null;
        // }
        // this.mSoundId = await O1HD.getManagers().soundMgr.playSound("");
        let soundId:string[] = ["meimeitalk","zhiyintalk","geyaozitalk"];
        let nextPageIndex:number = 0;
        if ( uniqueStr == "left" ) {
            nextPageIndex = this.pageView.getCurrentPageIndex() - 1 ;
            this.pageView.setCurrentPageIndex( nextPageIndex);
        }else{
            nextPageIndex = this.pageView.getCurrentPageIndex() + 1;
            this.pageView.setCurrentPageIndex( nextPageIndex );
        }
        if(this.mSoundId){
            O1HD.getManagers().soundMgr.stopSound(this.mSoundId);
        }
        if ( uniqueStr != "4" ) {
            O1HD.getManagers().soundMgr.playSound(soundId[nextPageIndex]).then((id:number)=>{
                this.mSoundId = id;
            });
        }

        if ( this.pageView.getCurrentPageIndex() == 3 ) {
            this.rightNode.active = false;
        }else{
            this.rightNode.active = true;
        }

        if ( this.pageView.getCurrentPageIndex() == 0 ) {
            this.leftNode.active = false;
        }else{
            this.leftNode.active = true;
        }
    }

    /**
     *
     */
    pageChange( pageView ){
        if ( pageView.getCurrentPageIndex() == 3 ) {
            this.rightNode.active = false;
        }else{
            this.rightNode.active = true;
        }

        if ( pageView.getCurrentPageIndex() == 0 ) {
            this.leftNode.active = false;
        }else{
            this.leftNode.active = true;
        }
    }

    /**
     * 选择girl
     */
    onBtnSelectGirl( e , define : string ){
        //隐藏 毛玻璃选女生幕布
        this.node.getChildByName("bgBlur").active = false;
        if ( define == "4" ){
            this.node.getChildByName("girlNode").scale = 1.24;
        }else if ( define == "3" ){
            this.node.getChildByName("girlNode").scale = 0.6;
        }else if ( define == "2" ) {
            this.node.getChildByName("girlNode").scale = 0.5;
        }else{
            this.node.getChildByName("girlNode").scale = 1;
        }
        if(this.mSoundId){
            O1HD.getManagers().soundMgr.stopSound(this.mSoundId);
        }
        O1HD.getManagers().gameMgr.getCurrMode().bundle.load(`res/massage/girl${define}`,cc.SpriteFrame,(error,assets : cc.SpriteFrame )=>{
            if ( error ) {
                console.log("找不到按摩小妹");
                return;
            }
            this.node.getChildByName("girlNode").getComponent(cc.Sprite).spriteFrame = assets;
        });

        //初始化女生，开始 拉开门帘，播放音效
        O1HD.getManagers().soundMgr.playSound("gaogenxie");
        cc.tween( this.node.getChildByName("curtainMaskNode") )
            .to( 1.5, {width:0})
            .call(()=>{
                // 初始化选择选项
                this.node.getChildByName("contentNode").active = true;
            })
            .start();
    }

    protected onDisable(): void {
        if(this.mSoundId){
            O1HD.getManagers().soundMgr.stopSound(this.mSoundId);
        }
    }

}
